import axios from 'axios';
import { getAuthHeaders } from './auth';

// Use Cloudflare Worker URL in production, localhost in development
// Set REACT_APP_API_URL environment variable to your deployed Worker URL
// Example: REACT_APP_API_URL=https://cloudflare-demo.your-subdomain.workers.dev/api
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://cloudflare-demo.favywoo.workers.dev/api'  // Your deployed Worker URL
    : 'http://localhost:8787/api');

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const headers = getAuthHeaders();
  config.headers = { ...config.headers, ...headers };
  return config;
});

export default api;

